import { captureEvent } from '../metrics/captureEvent'

/**
 * Captures submit performance
 * @param {number} perf
 */
export function captureSubmitPerformance(perf) {
  const perfThreshold = 5000
  if (perf < perfThreshold) {
    return
  }

  const event = `form-performance-above-${perfThreshold}`
  const performance = `${perf.toFixed(2)}ms`

  captureEvent(event, {
    performance,
  })
}
